import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import CartItem from '../components/CartItem';
import { ShoppingBag, ArrowRight } from 'lucide-react';

const Cart = () => {
  const navigate = useNavigate();
  const { cartItems, getCartTotal, getCartCount } = useCart();
  const total = getCartTotal();
  const itemCount = getCartCount();

  if (cartItems.length === 0) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <ShoppingBag className="w-24 h-24 text-gray-700 mx-auto mb-6" />
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-testid="empty-cart-message">
            Votre panier est vide
          </h2>
          <p className="text-gray-500 mb-6">
            Découvrez nos produits et commencez vos achats !
          </p>
          <Link
            to="/products"
            className="inline-block bg-cyan-500 text-white font-semibold px-8 py-3 rounded-lg hover:bg-cyan-600 transition"
            data-testid="continue-shopping-empty"
          >
            Découvrir nos produits
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-8" data-testid="cart-page-title">
          Panier ({itemCount} {itemCount > 1 ? 'articles' : 'article'})
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Cart Items */}
          <div className="lg:col-span-2 space-y-4">
            {cartItems.map(item => (
              <CartItem key={item.id} item={item} />
            ))}
          </div>

          {/* Summary */}
          <div className="lg:col-span-1">
            <div className="bg-gray-50 rounded-lg p-6 border border-gray-200 sticky top-20">
              <h2 className="text-xl font-bold text-gray-900 mb-6">Résumé</h2>

              <div className="space-y-3 mb-6">
                <div className="flex justify-between text-gray-500">
                  <span>Sous-total</span>
                  <span data-testid="cart-subtotal">{total.toLocaleString('fr-DZ')} DA</span>
                </div>
                <div className="flex justify-between text-gray-500">
                  <span>Livraison</span>
                  <span className="text-cyan-400">Calculée à la commande</span>
                </div>
                <div className="border-t border-gray-200 pt-3 flex justify-between text-gray-900 font-bold text-xl">
                  <span>Total</span>
                  <span data-testid="cart-total">{total.toLocaleString('fr-DZ')} DA</span>
                </div>
              </div>

              <button
                onClick={() => navigate('/checkout')}
                className="w-full bg-cyan-500 text-white font-bold py-4 rounded-lg hover:bg-cyan-600 transition flex items-center justify-center gap-2"
                data-testid="proceed-to-checkout"
              >
                Passer la commande
                <ArrowRight className="w-5 h-5" />
              </button>

              <Link
                to="/products"
                className="block text-center text-gray-500 hover:text-gray-900 mt-4 transition"
                data-testid="continue-shopping"
              >
                Continuer mes achats
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;